import React, { useState, useEffect, useRef } from 'react';

const ContentPopup = () => {
  const [hasAnimated, setHasAnimated] = useState([false, false, false, false, false]);
  const [counter, setCounter] = useState(0); // For animated number

  const sectionRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  useEffect(() => {
    const observers = sectionRefs.map((ref, index) => {
      return new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !hasAnimated[index]) {
            setHasAnimated((prev) => {
              const updated = [...prev];
              updated[index] = true;
              return updated;
            });

            if (index === 2) animateNumber(92); // Trigger roller animation
          }
        },
        { threshold: 0.5 }
      );
    });

    sectionRefs.forEach((ref, index) => {
      if (ref.current) observers[index].observe(ref.current);
    });

    return () => {
      sectionRefs.forEach((ref, index) => {
        if (ref.current) observers[index].unobserve(ref.current);
      });
    };
  }, [hasAnimated]);

  const animateNumber = (target) => {
    let start = 0;
    const duration = 1500;
    const stepTime = 1000 / 60; // ~60fps
    const increment = target / (duration / stepTime);
    let current = start;

    const step = () => {
      current += increment;
      if (current < target) {
        setCounter(Math.floor(current));
        requestAnimationFrame(step);
      } else {
        setCounter(target);
      }
    };

    requestAnimationFrame(step);
  };

  return (
    <div className='mt-8'>
      <div
        ref={sectionRefs[2]}
        style={{
          opacity: hasAnimated[2] ? 1 : 0,
          transform: hasAnimated[2] ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 1s, transform 1s',
          backgroundColor: '#1e3a8a',
          color: '#fff',
          padding: '20px',
          textAlign: 'center',
        }}
      >
        <div className="flex justify-center items-center bg-[#1e3a8a] py-8">
          <div className='flex flex-col justify-center'>
            <h3 className="text-2xl font-semibold">Proven Performance You Can Trust</h3>

            <p className="text-[#fff] mt-8 text-lg">
              RDx has been validated with rigorous datasets and achieved a{' '}
              <span
                style={{
                  color: '#ea580c',
                  fontSize: '28px',
                  fontWeight: 'bold',
                  display: 'inline-block',
                  transition: 'all 1s ease-out'
                }}
              >
                {counter}%
              </span>{' '}
              accuracy rate.
            </p>

            <div className="flex justify-center pl-6 mt-6">
              <button
                style={{
                  padding: '1rem 2rem',
                  borderRadius: '16px',
                  fontWeight: 600,
                  color: 'white',
                  backgroundColor: '#ea580c',
                  textAlign: 'center',
                  display: 'inline-block',
                  cursor: 'pointer'
                }}
              >
                Book a Demo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentPopup;
